import client from '../config/AxiosConfig';

export const GetNextEvents = async () => client.get('/events/next');
export const GetNextAlerts = async () => client.get('/alerts/next');
export const GetLowMaterials = async () => client.get('/materials/low');
